import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "fluid-layout",
  class: "h-full"
}
const _hoisted_2 = {
  key: 0,
  class: "w-full",
  style: {"background-color":"#55B48B","color":"white","text-align":"center","padding":"5px"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { style: {"margin":"auto","text-align":"center"} }, " 🎉Welcome to the Datakudo live demo! Ready for your own data? Click below to craft your own Space ", -1)
const _hoisted_4 = { class: "d-flex h-full w-full" }
const _hoisted_5 = {
  id: "main-wrapper",
  class: "d-flex w-full h-full"
}
const _hoisted_6 = {
  id: "content",
  class: "p-6 d-flex w-full h-full"
}
const _hoisted_7 = {
  key: 0,
  class: "d-flex flex-column w-full"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductNavBarHorizontalComponent = _resolveComponent("ProductNavBarHorizontalComponent")!
  const _component_ProductNavBarVerticalComponent = _resolveComponent("ProductNavBarVerticalComponent")!
  const _component_BrandNavBarComponent = _resolveComponent("BrandNavBarComponent")!
  const _component_FilterNavBarComponent = _resolveComponent("FilterNavBarComponent")!
  const _component_AlertsGroup = _resolveComponent("AlertsGroup")!
  const _component_UnsavedChangedModal = _resolveComponent("UnsavedChangedModal")!
  const _component_RequirePaymentModal = _resolveComponent("RequirePaymentModal")!
  const _component_ProgressBarComponent = _resolveComponent("ProgressBarComponent")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ProductNavBarHorizontalComponent),
      (_ctx.$store.state?.organization?.demo === true)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("button", {
              class: "btn btn-sm text-white btn-brand",
              style: {"margin":"auto"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (
								_ctx.$router.push({
											name: _ctx.$config(
												'RouteConfig',
												'OrganizationCreateRouteName'
											),
                })
							)),
              type: "button"
            }, _toDisplayString(_ctx.$beautify.firstLetterUppercase(
              _ctx.$text('actions', 'Create_An_Organization')
          )), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_ProductNavBarVerticalComponent),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", {
            id: "main",
            class: "col bg-secondary",
            style: _normalizeStyle(_ctx.$store.state?.organization?.demo === true ? 'height: calc(100% - 4rem) !important; ': '')
          }, [
            _createElementVNode("div", _hoisted_6, [
              (
								_ctx.$config('RouteConfig', 'FilterableRouteNames').includes(
									_ctx.$route.name
								) === true
							)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_BrandNavBarComponent),
                    _renderSlot(_ctx.$slots, "default")
                  ]))
                : _renderSlot(_ctx.$slots, "default", { key: 1 })
            ])
          ], 4),
          (
						_ctx.$config('RouteConfig', 'FilterableRouteNames').includes(
							_ctx.$route.name
						) === true
					)
            ? (_openBlock(), _createBlock(_component_FilterNavBarComponent, { key: 0 }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode(_component_AlertsGroup),
    _createVNode(_component_UnsavedChangedModal),
    _createVNode(_component_RequirePaymentModal),
    _createVNode(_component_ProgressBarComponent)
  ], 64))
}